import { RecordsEffect } from './records.effects';
import { UIEffect } from './ui.effects';
import { WorklistEffects } from './worklist.effects';

export const effects: any[] = [RecordsEffect, UIEffect, WorklistEffects];
